import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class SiteThermaForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      name: '',
      description: '',
      checkInput: [],
      siteThermaList: [],
      thermaArr: [],
      authorisedKey: '',
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  checkboxChangeHandler = event => {
    this.setState({
      checkInput: [...this.state.checkInput, event.target.name],
    });

    const found = this.state.thermaArr.findIndex(
      e => e.locationkey === event.target.id,
    );

    if (event.target.checked) {
      if (found < 0) {
        const therma = this.state.siteThermaList.find(
          e => e.locationkey === event.target.id,
        );
        this.state.thermaArr.push(therma);
      }
    } else {
      var tempArr = [...this.state.thermaArr];
      tempArr.splice(found, 1);
      this.setState({ thermaArr: tempArr });
    }
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    if (this.state.thermaArr.length < 1) {
      this.props.onCloseModal(
        <MdClear />,
        'Invalid submit. No therma location is selected',
        'error',
      );
      return;
    }

    for (let tl of this.state.thermaArr) {
      const data = {
        sitekey: this.props.match.params.id,
        locationkey: tl.locationkey,
        requesteduser:
          user.name === null || user.name === '' ? user.email : user.name,
      };

      axios
        .post('https://zoidapi.pseudoscops.com:3005/v1/extapi/therma/add', data)
        .then(response => {
          const result = response.data;

          if (result.error == false && result.message == 'Success') {
            this.props.closeModal(
              <MdDone />,
              'Therma location added successfully.',
              'success',
              false,
            );

            this.props.getSiteThermaList();
          }
        })
        .catch(error => {
          alert(error);
        });
    }
  };

  getAuthorisedKey = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: org.CompanyID,
    };

    axios
      .post(url + ':3000/v1/configuration/getAuthorisedkey', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        this.setState({ authorisedKey: result.data });
        this.getThermaLocation(result.data);

        //this.setState({ authorisedKey: result.data.AuthorisedKey });
        //this.getThermaLocation(result.data.AuthorisedKey);
      })
      .catch(error => {
        alert(error);
      });
  };

  getThermaLocation = key => {
    const data = {
      therma: key,
    };

    // const data = {
    //   therma: [{ authorisekey: key }],
    // };

    axios
      .post('https://zoidapi.pseudoscops.com:3005/v1/extapi/therma', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if (result.data.length > 0) {
          this.setState({ siteThermaList: result.data[0] });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    this.getAuthorisedKey();
  }

  render() {
    console.log(this.props);
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          Site Therma Information
        </ModalHeader>
        <ModalBody>
          <Table responsive hover className="ps-table">
            <thead>
              <tr>
                <th>Select</th>
                <th>Name</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {this.state.siteThermaList.length < 1 && (
                <tr>
                  <td colSpan="3">
                    <div className="ps-empty-data">
                      <div className="empty-content">
                        <MdCreate />
                        <h4>No data to show</h4>
                        <span>No site therma to import</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}

              {this.state.siteThermaList.length > 0 &&
                this.state.siteThermaList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <FormGroup check>
                          <Input
                            type="checkbox"
                            name={item.locationkey}
                            id={item.locationkey}
                            value={index}
                            onChange={this.checkboxChangeHandler}
                          />
                        </FormGroup>
                      </td>
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            {this.props.data.isEdit ? 'Save' : 'Add Site Therma'}
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default SiteThermaForm;
